
import Vue from 'vue';
import { message, notification } from 'ant-design-vue';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Cookies from 'js-cookie';
moment.locale('zh-cn');

const TokenKey = 'account-Token';
let domainName = '';
if (process.env.NODE_ENV === 'development') {
  domainName = location.hostname;
} else if (process.env.NODE_ENV === 'production') {
  domainName = 'ehaomiao.com';
} else {
  domainName = 'ehaomiao.net';
}
export const CookieApi = Cookies.withAttributes({ domain: domainName, expires: 30 });
console.log('domainName: ', domainName);

const Common = {
  /** 获取access token */
  getToken () {
    return CookieApi.get(TokenKey);
  },
  /** 存储 token */
  setToken (token) {
    return CookieApi.set(TokenKey, token);
  },
  /** 清除 token */
  removeToken () {
    return CookieApi.remove(TokenKey);
  },
  /**
   *  数据保存到localStorage
   * @param key
   * @param value
   */
  setLocal (key, value) {
    if (value === undefined || key === undefined) {
      return;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      localStorage[key] = value;
    } else if (typeof value === 'object' && value !== null) {
      localStorage[key] = JSON.stringify(value);
    }
  },

  /**
   * 获取localStorage数据
   * @param key
   * @returns {any}
   */
  getLocal (key) {
    if (!localStorage[key]) {
      return;
    }
    let value = localStorage[key];
    let index1 = value.indexOf('[');
    let index2 = value.indexOf('{');
    if (index1 >= 0 || index2 >= 0) {
      value = JSON.parse(localStorage[key]);
    }
    return value;
  },
  /**
   * 消息提示
   */
  message (param) {
    let type = param['type'] || 'success';
    message[type](param['message'] || '消息提示', param['duration'] || 3, param.callback);
  },
  /**
   * 清空搜索条件
   * @param selectData 重置对象
   * @param excludeKey 不重置的字段
   */
  resetData (selectData, excludeKey = []) {
    if (selectData && Object.keys(selectData).length) {
      let arr = ['page', 'pagesize', 'app_type']; // app_type单独处理社区、管家app菜单
      excludeKey.length && (arr = [...arr, ...excludeKey]);
      for (let item in selectData) {
        if (arr.every(el => el !== item)) {
          if (Array.isArray(selectData[item])) {
            selectData[item] = [];
          } else if (typeof selectData[item] !== 'undefined') {
            selectData[item] = undefined;
          }
        }
      }
    }
    return selectData;
  },
  /**
   *  过滤value为空的参数
   * @param obj
   */
  filterParam (obj) {
    var paramObj = {};
    for (var i in obj) {
      if (obj[i] !== '' && (obj[i] !== undefined)) {
        paramObj[i] = obj[i];
      }
    }
    return paramObj;
  },
  /**
   * 隐藏手机号中间四位
   * @param mobile
   * @returns {string}
   */
  hideMobileNum (mobile) {
    return mobile && `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
  },
  /* date picker 禁用时间范围 */
  disabledDate (date) {
    return date < moment(new Date());
  },
  /* 检测网络状态 */
  netWorkStatus () {
    let img = new Image();
    img.src = require('../assets/images/ehm.png');
    img.onload = function (e) {
    };
    img.onerror = function (e) {
      notification.error({ message: '网络连接异常' });
    };
  },
  /**
   *  查看图片
   * @param url
   */
  showPicture (url) {
    if (url) {
      window.open(url);
    } else {
      this.$message.error('图片地址为空');
    }
  },
  /**
   * 根据天气code返回icon
   * @param code
   * @returns {*}
   */
  getWeatherIcon (code) {
    let weatherDict = {
      100: {txt: '晴', icon: '100'},
      101: {txt: '多云', icon: '101'},
      102: {txt: '少云', icon: '102'},
      103: {txt: '晴间多云', icon: '103'},
      104: {txt: '阴', icon: '104'},
      200: {txt: '有风', icon: '200'},
      201: {txt: '平静', icon: '201'},
      202: {txt: '微风', icon: '202'},
      203: {txt: '和风', icon: '203'},
      204: {txt: '清风', icon: '204'},
      205: {txt: '强风/劲风', icon: '205'},
      206: {txt: '疾风', icon: '206'},
      207: {txt: '大风', icon: '207'},
      208: {txt: '烈风', icon: '208'},
      209: {txt: '风暴', icon: '209'},
      210: {txt: '狂爆风', icon: '210'},
      211: {txt: '飓风', icon: '211'},
      212: {txt: '龙卷风', icon: '212'},
      213: {txt: '热带风暴', icon: '213'},
      300: {txt: '阵雨', icon: '300'},
      301: {txt: '强阵雨', icon: '301'},
      302: {txt: '雷阵雨', icon: '302'},
      303: {txt: '强雷阵雨', icon: '303'},
      304: {txt: '雷阵雨伴有冰雹', icon: '304'},
      305: {txt: '小雨', icon: '305'},
      306: {txt: '中雨', icon: '306'},
      307: {txt: '大雨', icon: '307'},
      308: {txt: '极端降雨', icon: '308'},
      309: {txt: '毛毛雨/细雨', icon: '309'},
      310: {txt: '暴雨', icon: '310'},
      311: {txt: '大暴雨', icon: '311'},
      312: {txt: '特大暴雨', icon: '312'},
      313: {txt: '冻雨', icon: '313'},
      314: {txt: '小到中雨', icon: '314'},
      315: {txt: '中到大雨', icon: '315'},
      316: {txt: '大到暴雨', icon: '316'},
      317: {txt: '暴雨到大暴雨', icon: '317'},
      318: {txt: '大暴雨到特大暴雨', icon: '318'},
      399: {txt: '雨', icon: '399'},
      400: {txt: '小雪', icon: '400'},
      401: {txt: '中雪', icon: '401'},
      402: {txt: '大雪', icon: '402'},
      403: {txt: '暴雪', icon: '403'},
      404: {txt: '雨夹雪', icon: '404'},
      405: {txt: '雨雪天气', icon: '405'},
      406: {txt: '阵雨夹雪', icon: '406'},
      407: {txt: '阵雪', icon: '407'},
      408: {txt: '小到中雪', icon: '408'},
      409: {txt: '中到大雪', icon: '409'},
      410: {txt: '大到暴雪', icon: '410'},
      499: {txt: '雪', icon: '499'},
      500: {txt: '薄雾', icon: '500'},
      501: {txt: '雾', icon: '501'},
      502: {txt: '霾', icon: '502'},
      503: {txt: '扬沙', icon: '503'},
      504: {txt: '浮尘', icon: '504'},
      507: {txt: '沙尘暴', icon: '507'},
      508: {txt: '强沙尘暴', icon: '508'},
      509: {txt: '浓雾', icon: '509'},
      510: {txt: '强浓雾', icon: '510'},
      511: {txt: '中度霾', icon: '511'},
      512: {txt: '重度霾', icon: '512'},
      513: {txt: '严重霾', icon: '513'},
      514: {txt: '大雾', icon: '514'},
      515: {txt: '特强浓雾', icon: '515'},
      900: {txt: '热', icon: '900'},
      901: {txt: '冷', icon: '901'},
      999: {txt: '未知', icon: '999'}
    };
    if (weatherDict[code]) {
      return weatherDict[code].icon;
    } else {
      return false;
    }
  },
  /**
   * 列表轮播
   * @param obj
   */
  carousel (obj) {
    if (!obj.interval) { return; }
    this.$nextTick(() => {
      let item = this.$refs[obj.ref][0];
      let bound = item.getBoundingClientRect();
      let height = parseFloat(bound.height.toFixed(2));
      let puase = 300; // 暂停 300毫秒
      let move = height * (obj.speed || 32); // 一像素用时：36毫秒
      item.style = `margin-top: ${-height}px; transition: ${move / 1000}s linear;`;

      let moveTimeout = setTimeout(() => {
        item.style = '';
        let first = obj.list[0];
        obj.list.push(first);
        obj.list.shift();
        clearTimeout(moveTimeout);

        let pauseTimeout = setTimeout(() => {
          clearTimeout(pauseTimeout);
          this.carousel(obj);
        }, puase);
      }, move);
    });
  },
  /**
   * 补全长度小于6的数组
   * @param arr
   * @returns {*}
   */
  replenishList (arr) {
    let len = arr.length;
    if (len && len < 6) {
      let less = 6 - len;
      if (less < len) {
        arr.push(...arr.slice(0, less));
      } else { // less >= len
        let num = Math.ceil(less / len);
        let arr1 = JSON.parse(JSON.stringify(arr));
        for (let i = 0; i < num; i++) {
          arr.push(...arr1);
        }
      }
    }
    return arr;
  },
  /**
   * 定时器间隔时长
   * @returns {number}
   */
  intervalTime () {
    return 1000 * 60 * 20; // 20分钟
  },
  /**
   * 返回数组指定key选项的index
   * @param list
   * @param key
   * @returns {number}
   */
  gainListIndex (list, key) {
    if (!Array.isArray(list)) {
      return;
    }
    for (let i = 0; i < list.length; i++) {
      let el = list[i];
      let props = el.props && el.props[0];
      if (props === key) {
        return i;
      }
    }
  },
  /* 转换数据 */
  transformData (res) {
    let face = [];
    let blueTooth = [];
    let remote = [];
    let password = [];
    let card = [];
    let video = [];
    let date = [];
    let indoorVideo = [];
    let indoorNet = [];
    let phone = [];
    let visitorPwd = [];

    res.forEach((ele) => {
      face.push(ele.face);
      blueTooth.push(ele.shake);
      remote.push(ele.net);
      password.push(ele.pwd);
      card.push(ele.ic_card);
      video.push(ele.video);
      indoorVideo.push(ele.indoor_video);
      indoorNet.push(ele.indoor_net);
      phone.push(ele.ivr);
      visitorPwd.push(ele.visitor_pwd);

      date.push(ele.date || ele.hour.split(':')[0]);
    });
    return {
      face,
      blueTooth,
      remote,
      password,
      card,
      video,
      date,
      indoorVideo,
      indoorNet,
      phone,
      visitorPwd
    };
  },
  /* 排序方法 */
  compareFn (propertyName) {
    return function (obj1, obj2) {
      var value1 = obj1[propertyName];
      var value2 = obj2[propertyName];
      if (value1 < value2) {
        return 1;
      } else if (value1 > value2) {
        return -1;
      } else {
        return 0;
      }
    };
  },
  /**
   * 序列化对象数据
   * @param source
   * @returns {any}
   */
  serializeData (source) {
    return JSON.parse(JSON.stringify(source));
  },
  /** 获取可视化页面的查询数据 */
  getDataViewQuery (self) {
    let query = self.$route.query;
    if (Object.keys(query).length) {
      self.cId = query.id;
      let str = query.name;
      const specialChar = '/';
      let index = str.indexOf(specialChar);
      self.communityName = str.substring(index + 1);
    }
  },
  /** 打开新页签 */
  openNewTab (path, communityId) {
    if (communityId) {
      window.open(`${location.protocol}//${location.host}/#/${path}?communityId=${communityId}`);
    } else {
      window.open(`${location.protocol}//${location.host}/#/${path}`);
    }
  }
};

for (let item in Common) {
  Vue.prototype[item] = Common[item];
}

export default Common;
